import { render, staticRenderFns } from "./ChangeOrderStatusModal.vue?vue&type=template&id=5c6e77cc&scoped=true&"
import script from "./ChangeOrderStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e77cc",
  null
  
)

export default component.exports